// Module
var code = "<svg viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m12.037 15 6.837-7.226a.47.47 0 0 0 0-.64.411.411 0 0 0-.606 0l-7.142 7.547a.47.47 0 0 0 0 .64l7.142 7.545a.407.407 0 0 0 .603 0 .47.47 0 0 0 0-.64L12.037 15z\"/></svg>";
// Exports
module.exports = code;